import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const tableData = {
  row1: [
    '',
    'Taxable Years 2005, 2006 and 2007',
    'Taxable Years 2008 and 2009',
    'Taxable Years 2010 and 2011',
    'Taxable Years 2012 and Beyond',
  ],
  row2: [
    'Single',
    '$7,000',
    '$11,250',
    '$11,650',
    '$11,950',
  ],
  row3: [
    'Married',
    '$14,000',
    '$22,500',
    '$23,300',
    '$23,900',
  ],
  row4: [
    'Married, filing a separate return',
    '$7,000',
    '$11,250',
    '$11,650',
    '$11,950',
  ],
};

export const ageAndBlindnessOptions = [
  {
    id: 'yourself_age_65',
    title: 'If you will be 65 or older on January 1',
    state: 'yourselfAge65',
  },
  {
    id: 'spouse_age_65',
    title: 'If your spouse will be 65 or older on January 1',
    state: 'spouseAge65',
  },
  {
    id: 'yourself_blind',
    title: 'If you are legally blind',
    state: 'yourselfBlind',
  },
  {
    id: 'spouse_blind',
    title: 'If your spouse is legally blind',
    state: 'spouseBlind',
  },
];

export const initialAdditionalQuestions = [
  {
    id: 'additional_withholding',
    title: 'Enter the amount of additional withholding requested.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
